module.exports = {"TXTCLI_City":{"id":"TXTCLI_City","defaultMessage":"Город","flags":["TRACK"],"track":"City"}}